import type { GetInstructorsPendingLetterResult } from '@features/instructors/api/get-instructors-pending-letter/getInstructorsPendingLetter.types';
import type { GetInstructorsUnapprovedResult } from '@features/instructors/api/get-instructors-unapproved/getInstructorsUnapproved.types';
import type { TileContent } from '@features/instructors/types/tile.types';

export function buildUnapprovedTileContent(
  unapprovedData: GetInstructorsUnapprovedResult | undefined,
  isError = false,
  isLoading = false
): TileContent | null {
  if (isError) return null;

  if (isLoading && !unapprovedData) {
    return {
      type: 'instructors-to-approve',
      count: 0,
      description: '',
      showInfoIcon: false,
      isLoading: true,
    };
  }

  if (!unapprovedData) return null;

  const { instructorCount, groundSchool, simulator, simCheck } = unapprovedData;

  if (instructorCount === 0) return null;

  const hasDisciplines = [groundSchool, simulator, simCheck].some(
    discipline => discipline.length > 0
  );

  if (!hasDisciplines) return null;

  const description =
    instructorCount === 1
      ? 'Instructor available to be approved for training your crew members'
      : 'Instructors available to be approved for training your crew members';

  return {
    count: instructorCount,
    description,
    showInfoIcon: true,
    type: 'instructors-to-approve',
    isLoading,
  };
}

export function buildPendingLetterTileContent(
  pendingLetterData: GetInstructorsPendingLetterResult | undefined,
  isError = false,
  isLoading = false
): TileContent | null {
  if (isError) return null;

  if (isLoading && !pendingLetterData) {
    return {
      type: 'approval-letters',
      count: 0,
      description: '',
      showInfoIcon: false,
      isLoading: true,
    };
  }

  if (!pendingLetterData) return null;

  const { instructorCount, pendingApprovalLetters } = pendingLetterData;

  if (instructorCount === 0 || pendingApprovalLetters.length === 0) return null;

  const description =
    instructorCount === 1
      ? 'Check airman requires their approval letter, please upload them now'
      : 'Check airmen require their approval letter, please upload them now';

  return {
    type: 'approval-letters',
    count: instructorCount,
    description: description,
    showInfoIcon: true,
    isLoading,
  };
}

export function buildProcessingRequestsTileContent(
  isProcessing: boolean,
  processingCount: number
): TileContent | null {
  if (!isProcessing) return null;

  const description =
    processingCount === 1
      ? 'Request is being submitted'
      : 'Requests are being submitted';

  return {
    count: processingCount,
    description,
    type: 'processing-requests',
    showProcessingLoader: true,
  };
}
